'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _CheckboxConstants = require('./CheckboxConstants');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UICheckbox',


  propTypes: {
    alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
    'aria-label': _react.PropTypes.string,
    checked: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    indeterminate: _react.PropTypes.bool,
    inline: _react.PropTypes.bool,
    innerPadding: _react.PropTypes.oneOf(['none', 'default']).isRequired,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOf(['small', 'default']),
    value: _react.PropTypes.any
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alignment: 'start',
      innerPadding: 'default',
      size: 'default'
    };
  },
  checkboxRefCallback: function checkboxRefCallback(ref) {
    this._checkboxEl = ref;
  },
  getLabelClassName: function getLabelClassName(_ref) {
    var alignment = _ref.alignment,
        children = _ref.children,
        className = _ref.className,
        inline = _ref.inline,
        innerPadding = _ref.innerPadding,
        size = _ref.size;

    return (0, _reactUtils.classNames)('private-checkbox', _CheckboxConstants.ALIGNMENT_CLASSES[alignment], {
      'private-checkbox--inline': inline,
      'private-checkbox--small': size === 'small',
      'private-checkbox--flush': innerPadding === 'none',
      'private-checkbox--unlabeled': children == null
    }, className);
  },
  getLabelTextClassName: function getLabelTextClassName(_ref2) {
    var size = _ref2.size;

    return (0, _reactUtils.classNames)('private-checkbox__text', { 'private-checkbox__text--small': size === 'small' });
  },
  getCheckboxClassName: function getCheckboxClassName(_ref3) {
    var indeterminate = _ref3.indeterminate;

    return (0, _reactUtils.classNames)({ indeterminate: indeterminate }, 'sr-only', 'private-checkbox__input');
  },
  renderCheckmark: function renderCheckmark() {
    return _react2.default.createElement(_UICheckmark2.default, {
      className: 'private-checkbox__icon__inner'
    });
  },
  renderDash: function renderDash() {
    return _react2.default.createElement(
      'svg',
      {
        role: 'presentation',
        viewBox: '0 0 14 14',
        xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement('path', {
        className: 'private-checkbox__icon__inner',
        d: 'M 2 6 L12 6 L12 9 L2 9 L2 6 z'
      })
    );
  },
  renderLabelText: function renderLabelText(_ref4) {
    var ariaLabel = _ref4.ariaLabel,
        children = _ref4.children,
        size = _ref4.size;

    if (children == null && !ariaLabel) {
      _devLogger2.default.warn({
        message: 'UICheckbox: `aria-label` is required if you don\'t define `children`.',
        key: 'UICheckbox: aria-label required'
      });
    }

    if (children && ariaLabel) {
      _devLogger2.default.warn({
        message: 'UICheckbox: `aria-label` overrides `children` when provided, ' + 'avoid passing both properties.',
        key: 'UICheckbox: aria-label overrides children'
      });
    }

    return _react2.default.createElement(
      'span',
      {
        'aria-label': ariaLabel,
        className: this.getLabelTextClassName({ size: size }) },
      children
    );
  },
  render: function render() {
    var _props = this.props,
        alignment = _props.alignment,
        ariaLabel = _props['aria-label'],
        checked = _props.checked,
        children = _props.children,
        className = _props.className,
        color = _props.color,
        defaultChecked = _props.defaultChecked,
        disabled = _props.disabled,
        indeterminate = _props.indeterminate,
        inline = _props.inline,
        innerPadding = _props.innerPadding,
        name = _props.name,
        onChange = _props.onChange,
        readOnly = _props.readOnly,
        size = _props.size,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['alignment', 'aria-label', 'checked', 'children', 'className', 'color', 'defaultChecked', 'disabled', 'indeterminate', 'inline', 'innerPadding', 'name', 'onChange', 'readOnly', 'size', 'value']);

    return _react2.default.createElement(
      'label',
      _extends({}, rest, {
        className: this.getLabelClassName({ alignment: alignment, children: children, className: className, inline: inline, innerPadding: innerPadding, size: size })
      }),
      _react2.default.createElement(
        'span',
        { className: 'private-checkbox__inner' },
        _react2.default.createElement('input', {
          checked: checked,
          className: this.getCheckboxClassName({ indeterminate: indeterminate }),
          defaultChecked: defaultChecked,
          disabled: disabled,
          name: name,
          onChange: onChange,
          readOnly: readOnly,
          ref: this.checkboxRefCallback,
          type: 'checkbox',
          value: value
        }),
        _react2.default.createElement(
          'span',
          {
            className: 'private-checkbox__indicator',
            style: { color: color }
          },
          _react2.default.createElement(
            'span',
            { className: 'private-checkbox__icon private-checkbox__check' },
            this.renderCheckmark()
          ),
          _react2.default.createElement(
            'span',
            { className: 'private-checkbox__icon private-checkbox__dash' },
            this.renderDash()
          )
        ),
        this.renderLabelText({ ariaLabel: ariaLabel, children: children, size: size })
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/input/UICheckbox.js
// module id = 137
// module chunks = 0 1